
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Services from './components/Services';
import About from './components/About';
import Solutions from './components/Solutions';
import Testimonials from './components/Testimonials';
import WorkWithUs from './components/WorkWithUs';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Hero />
      <Services />
      <About />
      <Solutions />
      <Testimonials />
      <WorkWithUs />
      <Contact />
      <Footer />
    </div>
  );
}
